import React, { useEffect, useContext } from 'react'
// import { Redirect } from 'react-router-dom'
// import { connect } from 'react-redux'
// TODO get appRoutes from provider
// import { appRoutes } from '@brainstud/react-tbl/features'
// import { routeTo, getBySlug, getNextItem, getPrevItem } from '@brainstud/react-helpers'
// import { setProgress, viewQuestion, touchQuestion, submitQuestion } from '../../store'
// import { withModal } from '@brainstud/react-tbl/features/modals'
// import QuizContext from '../../QuizContext'
import Question from './Question'
import { useSetProgress, useViewQuestion } from '../../store'
import { useQuestionState } from '../../hooks'

const QuestionView = props => {
  const question = useQuestionState(props.match.params.question)

  useSetProgress('quiz', {
    location: 'question',
    question: props.match.params.question,
  }, [props.match.params.question], {
    question: null,
  })

  useViewQuestion(props.match.params.question)

  return <Question {...question} />
}

// class QuestionView extends React.Component {
//   onUpdate = data => {
//     this.props.touchQuestion(this.props.question.id, data)
//   }
//
//   submitQuestion = e => {
//     this.props.submitQuestion(this.props.question.id)
//   }
//
//   render() {
//     // if(!this.props.question)
//     //   return <Redirect to={routeTo(appRoutes, 'home')} />
//
//     return <Question {...this.props}
//       submitQuestion={this.submitQuestion}
//       onUpdate={this.onUpdate} />
//   }
// }

export default QuestionView
// export default withModal(connect(
//   (state, props) => {
//     const navigation = state.navigation.list.byId
//     const chapters = state.chapters.chapters.byId
//     const quizes = state.quizes.quizes.byId
//     const questions = state.quizes.questions.byId
//     const answersAll = state.quizes.answers.byId
//     const progressAll = state.quizes.progress
//     let quiz = {}
//     let type = ''
//
//     if(props.match.params.chapter) {
//       const chapter = getBySlug(chapters, props.match.params.chapter)
//       quiz = quizes[chapter.quizId]
//       type = 'quiz'
//     } else {
//       const navItem = Object.values(navigation).find(item => item.type === 'quiz')
//       quiz = quizes[navItem.quizId]
//       type = 'endtest'
//     }
//
//     const question = questions[`question-${quiz.prefix}-${props.match.params.question}`]
//     if(!question) return { quiz, question: false }
//
//     const progress = progressAll[question.id] || {}
//     const answers = question.answers.reduce((acc, item) => {
//       return acc.concat(answersAll[item])
//     }, [])
//
//     const quizProgress = progressAll[quiz.id] || {}
//     // const percent = (quizProgress.totalQuestions - quizProgress.remainingToSubmit) / quizProgress.totalQuestions * 100
//     const currentQIndex = quiz.questions.indexOf(question.id)+1
//     const progressbar = currentQIndex / quizProgress.totalQuestions * 100
//
//     const isFirstQuestion = quiz.questions.indexOf(quizProgress.question) === 0
//     const isLastQuestion = quiz.questions.indexOf(quizProgress.question) === quiz.questions.length-1
//
//     const nextQuestion = getNextItem(quiz.questions, questions, question.id) || {}
//     const prevQuestion = getPrevItem(quiz.questions, questions, question.id) || {}
//
//     const prevQuestionProgress = progressAll[prevQuestion.id] || {}
//     const prevQuestionStatus = prevQuestionProgress.submited && prevQuestionProgress.passed
//       ? 'correct'
//       : prevQuestionProgress.submited && !prevQuestionProgress.passed
//         ? 'wrong'
//         : ''
//
//     const nextQuestionProgress = progressAll[nextQuestion.id] || {}
//     const nextQuestionStatus = nextQuestionProgress.submited && nextQuestionProgress.passed
//       ? 'correct'
//       : nextQuestionProgress.submited && !nextQuestionProgress.passed
//         ? 'wrong'
//         : ''
//
//     return {
//       quiz,
//       quizProgress,
//       type,
//       question,
//       answers,
//       progress,
//       progressbar,
//       isFirstQuestion,
//       isLastQuestion,
//       prevQuestionStatus,
//       nextQuestionStatus,
//       currentQIndex,
//     }
//   },
//   (dispatch) => ({
//     setProgress: (anyId, progress) => dispatch(setProgress(anyId, progress)),
//     viewQuestion: qId => dispatch(viewQuestion(qId)),
//     touchQuestion: (qId, data) => dispatch(touchQuestion(qId, data)),
//     submitQuestion: qId => dispatch(submitQuestion(qId)),
//   })
// )(QuestionView))
